import list from './MassSendCustomer'

export default list
